import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@cbrebuild/blocks';
import './connector-restriction-banner.scss';

/**
 * ConnectorRestrictionBanner
 * Displays warning banner when user selects a restricted deal type and
 * user has connector restrictions with voucher access authorization flag enabled.
 */
const ConnectorRestrictionBanner = () => {

  return (
    <div className="connector-restriction-banner" role="alert" aria-live="polite">
      <div className="crb-inner">
        <Icon iconName="info-circle" className="crb-icon" />
        <span className="crb-text">
          ConnectorPro Vouchers/Early Invoices must be submitted in ConnectorPro. Deal IQ edits will be overwritten. Contact Connector Support (<a href="mailto:connectorsupport@cbre.com">connectorsupport@cbre.com</a>) for issues.
        </span>
      </div>
    </div>
  );
};

ConnectorRestrictionBanner.propTypes = {
  restrictedType: PropTypes.string,
};

ConnectorRestrictionBanner.defaultProps = {
  restrictedType: null,
};

export default ConnectorRestrictionBanner;